import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Animated, StyleSheet, Text, TouchableWithoutFeedback} from 'react-native';
import {View} from './source';

const COLORS = [
    '#65b237', // green
    '#346ca5', // blue
    '#a0a0a0', // light grey
    '#ffc508', // yellow
    '#217983', // cobolt
    '#435056', // grey
    '#b23751', // red
    '#333333', // dark
    '#ff6821', // orange
    '#e3a09e', // pink
    '#1abc9c', // turquoise
    '#302614', // brown
];

const _LIST = [
    {
        'title': 'Attention Seekers',
        'data': [
            'bounce',
            'flash',
            'jello',
            'pulse',
            'rotate',
            'rubberBand',
            'shake',
            'swing',
            'tada',
            'wobble',
        ],
    },//0
    {
        'title': 'Bouncing Entrances',
        'data': ['bounceIn', 'bounceInDown', 'bounceInUp', 'bounceInLeft', 'bounceInRight'],
    },//1
    {
        'title': 'Bouncing Exits',
        'data': ['bounceOut', 'bounceOutDown', 'bounceOutUp', 'bounceOutLeft', 'bounceOutRight'],
    },//2
    {
        'title': 'Fading Entrances',
        'data': [
            'fadeIn',
            'fadeInDown',
            'fadeInDownBig',
            'fadeInUp',
            'fadeInUpBig',
            'fadeInLeft',
            'fadeInLeftBig',
            'fadeInRight',
            'fadeInRightBig',
        ],
    },//3
    {
        'title': 'Fading Exits',
        'data': [
            'fadeOut',
            'fadeOutDown',
            'fadeOutDownBig',
            'fadeOutUp',
            'fadeOutUpBig',
            'fadeOutLeft',
            'fadeOutLeftBig',
            'fadeOutRight',
            'fadeOutRightBig',
        ],
    },//4
    {
        'title': 'Flippers',
        'data': ['flipInX', 'flipInY', 'flipOutX', 'flipOutY'],
    },//5
    {
        'title': 'Lightspeed',
        'data': ['lightSpeedIn', 'lightSpeedOut'],
    },//6
    {
        'title': 'Sliding Entrances',
        'data': ['slideInDown', 'slideInUp', 'slideInLeft', 'slideInRight'],
    },//7
    {
        'title': 'Sliding Exits',
        'data': ['slideOutDown', 'slideOutUp', 'slideOutLeft', 'slideOutRight'],
    },//8
    {
        'title': 'Zooming Entrances',
        'data': ['zoomIn', 'zoomInDown', 'zoomInUp', 'zoomInLeft', 'zoomInRight'],
    },//9
    {
        'title': 'Zooming Exits',
        'data': ['zoomOut', 'zoomOutDown', 'zoomOutUp', 'zoomOutLeft', 'zoomOutRight'],
    },//10
];

const styles = StyleSheet.create({
    cell: {
        padding: 16,
        marginBottom: 10,
        marginHorizontal: 10,
    },
    name: {
        color: 'white',
        fontSize: 16,
        textAlign: 'center',
    },
});

export default class HMAnimation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            duration: props.duration ? props.duration : 1000,
            toggledOn: false,
        };
    }

    componentDidMount() {
        if (this.props.StartAnimation) {
            if (this.props.delay) {
                setTimeout(function () {

                        this.handleRowPressed();
                    }.bind(this), this.props.delay ? this.props.delay : 100,
                );
            } else {
                this.handleRowPressed();
            }
        }
    }

    static propTypes = {
        // animationType: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired,
        //onPress: PropTypes.func.isRequired,
        useNativeDriver: PropTypes.bool.isRequired,
    };

    ref = null;
    handleRef = ref => {
        this.ref = ref;
    };

    // handlePress = () => {
    //     if (this.ref && this.props.onPress) {
    //         this.props.onPress(this.ref, this.props.animationType);
    //     }
    // };
    handleDurationChange = duration => {
        this.setState({duration: Math.round(duration)});
    };

    handleRowPressed(func) {
        let {indexList} = this.props;
        let number = indexList;
        /*    if (indexList) {
                let length = indexList.toString().length;
                number = indexList >= 10 ? parseInt(indexList.toString().substring(length - 2, length - 1)) : indexList;
            }*/

        //  console.log(indexList, indexList.toString().length)
        //  str.substring(0, str.length - 1)
        this.ref?.setNativeProps({
            style: {
                zIndex: 1,
            },
        });
        //  this.ref.animate(_LIST[this.props.animationTypeIndex].data[this.props.animationTypeIndexSub], this.state.duration * (number ? (number * .6) : .5)).then(() => {
        this.ref?.animate(_LIST[this.props.animationTypeIndex].data[this.props.animationTypeIndexSub], this.state.duration).then(() => {
            // this.ref.setNativeProps({
            //     style: {
            //         zIndex: 0,
            //     },
            // });
            func?.();
        });

    };

    render() {
        const {children, styleRoot, onPress,mouseAnimation} = this.props;

        return (
            <TouchableWithoutFeedback
              //  onPress={() => this.handleRowPressed(onPress)}
                onPress={onPress}
            >
                <View
                   // key={'i' + Math.random()}
                    ref={this.handleRef}
                    //  style={[{backgroundColor: COLORS[this.props.colorIndex]}, styles.cell]}
                    style={[styleRoot ? styleRoot : styles.cell]}
                    useNativeDriver={this.props.useNativeDriver}
                    onMouseEnter={
                        () => {
                            mouseAnimation&& this.handleRowPressed()
                            //   this.setStyles(hoverStyle)
                           // this.setState({hover: true})
                        }
                    }
                    onMouseLeave={

                        () => {
                            //this.setStyles(style)
                          //  this.setState({hover: false})
                        }
                    }

                >
                    {children}
                </View>
            </TouchableWithoutFeedback>
        );
    }
}
